import { FormGroup, Input, Label } from "reactstrap";
import { useThemeContext } from "../../Context/ThemeContext";
import { getDarkDropdown } from "../../Utils/otherFunctions";

const SelectionField = ({
  state,
  label,
  name,
  placeholder,
  defaultValue,
  value,
  options,
  optionsName,
  optionsValue,
  customOptions,
  onChange,
  className,
  disable,
  size,
}) => {
  const { themeContext } = useThemeContext();

  const defaultIfEmpty = (value) => {
    return value === "" ? "" : value;
  };

  const disabled = options?.length <= 1;

  return (
    <FormGroup className={className}>
      {label && (
        <Label for={name} className={"bg-transparent"}>
          {label}
        </Label>
      )}
      <Input
        aria-label={name}
        type="select"
        id={name}
        name={name}
        onChange={onChange}
        size={size}
        // defaultValue={defaultValue}
        value={defaultValue || value || (state && defaultIfEmpty(state[name]))}
        className={`${
          disabled && themeContext === "dark" && "bg-dark"
        } ${getDarkDropdown(themeContext)}`}
        disabled={disabled || disable}
      >
        {customOptions ? (
          <>
            {placeholder && <option>{placeholder}</option>}
            {customOptions}
          </>
        ) : !options || options.length <= 0 ? (
          <b>Ops, no one here yet</b>
        ) : (
          <>
            {placeholder && <option>{placeholder}</option>}
            {options.map((option) => {
              return (
                <option
                  disabled={option?.disabled}
                  value={option[optionsValue || optionsName || name]}
                >
                  {option[optionsName || name]}
                </option>
              );
            })}
          </>
        )}
      </Input>
    </FormGroup>
  );
};

export default SelectionField;
